<template>
  <div id="app">
    <notifications group="foo" />
    <AmaLink></AmaLink>
    <search-bar v-if="!checkOnRouteBanner() && start"></search-bar>
    <router-view v-if="start"></router-view>
    <Footer v-if="!isAma"></Footer>
    <FooterAma v-if="isAma"></FooterAma>

  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import configapi from "./api/configapi";
import "vue-slider-component/theme/default.css";
import SearchBar from "./components/SearchBar.vue";
import Footer from "./components/Footer.vue";
import Vue from "vue";
import FooterAma from "./components/ama/FooterAma.vue";
import AmaLink from "./components/AmaLink.vue";

export default {
  components: { SearchBar, Footer, FooterAma, AmaLink },
  name: "App",
  data: function () {
    return {
      start: false,
      objToSend: {},
      origin: null,
    };
  },
  computed: {
    ...mapState({
      theme: (state) => state.config.theme,
      selectedJewel: (state) => state.detail.selectedJewel,
      colors: (state) => state.config.pluginSettings,
      credential: (state) => state.config.credential,
      selectedProduct: (state) => state.productDetail.selectedProduct,
      retailPerc: (state) => state.detail.retailPerc,
      isAma: (state) => state.config.isAma,
    }),
    chatbotUrl() {
      const enc = this.credential && this.credential.apiEncryptedUser
        ? this.credential.apiEncryptedUser : '';
      const base = (process.env.VUE_APP_BASE_URL || '')
        .replace(/\/api\/jewelConfigurator\/?$/, '');
      return base + '/chatbot/chat.html' + (enc ? '?encryptedUser=' + encodeURIComponent(enc) : '');
    },
  },
  beforeMount: function () {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("message", onMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", onMessage, false);
    }

    function onMessage(event) {
      var data = event.data;


      this.origin = event.origin;
      /*if (
        event.origin != "http://localhost:3000" &&
        event.origin != "http://localhost:4200" &&
        event.origin != "http://localhost:8080" &&
        event.origin != "null" &&
        event.origin != "https://shop-test.gioielleriaitaliana.com" &&
        event.origin != "https://shop.gioielleriaitaliana.com" &&
        event.origin != "https://portale.gioielleriaitaliana.com" &&
        event.origin != "https://portale-test.gioielleriaitaliana.com"
      ) {
        return;
      } else {
        if (data.config) {
          self.init(data.config);
        }
      }*/

      if (data.config) {
        self.init(data.config);
      }

      //UNCOMMENT THIS IF YOU WANT TO TEST THE APPLICATION LOCALLY
      if (!self.inIframe() && !self.credential.locale)
        self.init({});
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      window.parent.postMessage(
        {
          func: "removeGioielleriaItalianaMessages",
          message: true,
        },
        "*"
      );
    },
  },
  mounted() {
    window.parent.postMessage(
      {
        func: "configuratorReady",
        message: true,
      },
      "*"
    );
    this.$root.$on('open-chatbot', this.openChatbot);
  },
  beforeDestroy() {
    this.$root.$off('open-chatbot', this.openChatbot);
  },
  destroyed() { },
  methods: {
    ...mapMutations("config", ["setPluginSettings", "setTheme", "setReady"]),
    ...mapMutations("config", ["setCredential", "setShowOnlyPublicPrice"]),
    ...mapMutations("detail", [
      "setPreselectedJewel",
      "setQuantity",
      "setRetailPerc",
      "setOrigin",
      "setVat",
    ]),
    ...mapMutations("productDetail", [
      "setPreselectedProduct",
      "setQuantityProduct",
      "setRetailProductPerc",
      "setOrigin",
      "setVatProduct",
    ]),
    openChatbot() {
      window.parent.postMessage({ func: 'openGioielleriaItalianaChatbot', message: { chatbotUrl: this.chatbotUrl } }, '*');
    },
    checkOnRoute() {
      return this.$route.name === "list";
    },
    checkOnRouteBanner() {
      return this.$route.name === "banner";
    },
    addToBasket: function () {
      // postMessage used to call a function call in the same way of the value func in the parent script.

      this.objToSend = JSON.parse(JSON.stringify(this.selectedJewel));

      delete this.objToSend.k;
      delete this.objToSend.placeholders;
      delete this.objToSend.optionPrice;
      delete this.objToSend.optionsJewel;

      window.parent.postMessage(
        {
          func: "addToGioielleriaItalianaBasket",
          message: this.objToSend,
        },
        "*"
      );
    },
    addToBasketProduct: function () {
      // postMessage used to call a function call in the same way of the value func in the parent script.

      this.objToSend = JSON.parse(JSON.stringify(this.selectedProduct));

      delete this.objToSend.k;
      delete this.objToSend.placeholders;
      delete this.objToSend.optionPrice;
      delete this.objToSend.optionsJewel;

      window.parent.postMessage(
        {
          func: "addToGioielleriaItalianaBasket",
          message: this.objToSend,
        },
        "*"
      );
    },
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }, init: function (config) {
      // this.setOrigin(self.origin);
      const root = document.documentElement;
      console.log(config);


      //UNCOMMENT THIS IF YOU WANT TO TEST THE APPLICATION LOCALLY
/*
      if (!config.section) config.section = "list";
      if (!config.credential) {
        config.credential = {
          apiKey: "pXJuv2SSHay1OWxIfV4sMVaI7",
          //apiEncryptedUser: "50a34b551e9482f4d724fca4f5ca2d485b777cff",
          locale: "it_IT",
          VAT: 1.22
        };

        this.$i18n.locale = config.credential.locale.slice(0, 2);
        this.setCredential(config.credential);
        this.setTheme(1);
      }
*/

      if (config && config.credential) {
        this.setCredential(config.credential);
        this.$i18n.locale = config.credential.locale.slice(0, 2);

        if (config.credential.VAT && config.credential.VAT > 1) {
          this.setVat(parseFloat(config.credential.VAT));
          this.setVatProduct(parseFloat(config.credential.VAT));
        }
      }

      if (!this.credential.apiEncryptedUser)
        configapi.getPluginLayout(
          (res) => {
            this.setPluginSettings(res.data);
            this.setTheme(res.data.theme ? res.data.theme : 1);

            if (res.data.theme === 2) {
              root.style.setProperty(
                `--primary-color-1`,
                getComputedStyle(document.documentElement).getPropertyValue(
                  `--primary-color-2`
                )
              );
              root.style.setProperty(
                `--secondary-color-1`,
                getComputedStyle(document.documentElement).getPropertyValue(
                  `--secondary-color-2`
                )
              );
              root.style.setProperty(
                `--fixed-primary-color-1`,
                getComputedStyle(document.documentElement).getPropertyValue(
                  `--fixed-primary-color-2`
                )
              );
            }
            // loop for each element arrived from the BE and assign a color to this variable (it depends on the nane)
            if (res.data) {
              for (const property in res.data) {
                if (res.data[property]) {
                  if (
                    property === "primary-color" ||
                    property === "secondary-color"
                  ) {
                    root.style.setProperty(
                      `--${property}-1`,
                      res.data[property]
                    );
                  } else {
                    root.style.setProperty(
                      `--${property}1`,
                      res.data[property]
                    );
                  }
                }
              }
            }

            root.style.setProperty(
              `--fixed-primary-color-1`,
              getComputedStyle(document.documentElement).getPropertyValue(
                `--primary-color-1`
              )
            );

            root.style.setProperty(
              `--fixed-secondary-color-1`,
              getComputedStyle(document.documentElement).getPropertyValue(
                `--secondary-color-1`
              )
            );

            this.initializeConfigurator(config.parentUrl);
          },
          () => {
            this.initializeConfigurator(config.parentUrl);
          }
        );
      else this.initializeConfigurator(config.parentUrl);
    },

    initializeConfigurator(parentUrl) {
      var mystr = window.location.href.replaceAll("#/", "");
      mystr = window.location.href.replaceAll("/#", "");
      var myUrl = new URL(mystr);
      const searchParams = new URLSearchParams(myUrl.search);
      const parentParams = parentUrl ? new URLSearchParams(new URL(parentUrl).search) : '';
      const params = Object.fromEntries(new URLSearchParams({ ...Object.fromEntries(searchParams), ...Object.fromEntries(parentParams) }).entries());

      if (this.isAma) {
        const root = document.documentElement;
        root.style.setProperty(
          `--primary-color-1`,
          getComputedStyle(document.documentElement).getPropertyValue(
            `--ama-black`
          )
        );
        root.style.setProperty(
          `--secondary-color-1`,
          getComputedStyle(document.documentElement).getPropertyValue(
            `--ama-gray`
          )
        );
        root.style.setProperty(
          `--font-family`,
          getComputedStyle(document.documentElement).getPropertyValue(
            `--font-family-general-sans`
          )
        );
        root.style.setProperty(
          `--secondary-font-family`,
          getComputedStyle(document.documentElement).getPropertyValue(
            `--font-family-reckless`
          )
        );
      }

      if (this.credential.banner) {
        this.$router.push({ name: "banner" });
      } else {
        // get value retailPerc in querystring and set as multiplier
        if (params["retailPerc"]) {
          if (!this.isAma) {
            this.setRetailPerc(JSON.parse(params["retailPerc"]));
            this.setRetailProductPerc(JSON.parse(params["retailPerc"]));
          }
          else {
            this.setShowOnlyPublicPrice(true);
          }
        }
        // get the object from the "json" querystring field e set it as preselectedjewel
        if (params["json"] || params["editJson"]) {
          if (params["json"]) {
            var jewel = JSON.parse(atob(params["json"]));
          } else {
            var jewel = JSON.parse(atob(params["editJson"]));
          }

          if (jewel.productType === 'STONE') {
            //stone category
            this.$router.push({
              name: "results.stones",
            });
          } else {
            if (Vue.isAccessory(jewel.productType)) {
              this.setPreselectedProduct(jewel);
              this.setQuantityProduct(jewel.quantity);
              this.setQuantity(1);
            } else {
              this.setPreselectedJewel(jewel);
              this.setQuantity(jewel.quantity);
              this.setQuantityProduct(1);
            }
            this.$router.push({
              name:
                jewel.productType && Vue.isAccessory(jewel.productType)
                  ? "product.detail"
                  : "list.detail",
              params: {
                sku: jewel.sku || jewel.skuBase || jewel.options.skuBase,
                kit: jewel.productType === "KIT",
                // type: jewel.options.jewelType,
                // typeId: jewel.options.jewelTypeId,
                direct: true,
              },
            });
          }
        }
        else if (params["sku"]) {

          this.$router.push({
            name: params["productType"] && Vue.isAccessory(params["productType"])
              ? "product.detail"
              : "list.detail",
            params: {
              sku: params["sku"],
              kit: params["productType"] === "KIT",
              direct: true,
            },
          });

          if (params["productType"] && Vue.isAccessory(params["productType"])) {
            this.setPreselectedProduct({ sku: params["sku"] });
          } else {
            this.setPreselectedJewel({ sku: params["sku"] });
          }
          this.setQuantity(1);
          this.setQuantityProduct(1);
        }
        else if (params["categoryId"] || params["productType"]) {
          if (params["productType"] && params["productType"] == 'STONE')
            this.$router.push({
              name: "results.stones",
            });
          else {
            this.$router.push({
              name: "list.sublist",
              params: {
                productType: params["productType"],
                typeId: params["categoryId"],
              },
            });
          }

          this.setQuantity(1);
          this.setQuantityProduct(1);
        } else {
          //this.$router.push({ name: "list" });
          this.setQuantity(1);
          this.setQuantityProduct(1);
        }
      }
      this.setReady(true);
      this.start = true;
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/_variables.scss";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--primary-color-1);
  font-family: var(--font-family);
  // min-height: 1000px;
  background: #ffffff;

  button {
    color: var(--primary-color-1);
    background-color: var(--secondary-color-1);
  }
}


html {
  //overflow: hidden;
}

.cursor-pointer {
  cursor: pointer;
}

.tooltip-vue {
  display: block !important;
  z-index: 10000;
}

.tooltip-vue .tooltip-vue-inner {
  background: var(--primary-color-1);
  color: white;
  border-radius: 16px;
  padding: 5px 10px 5px;
}

.tooltip-vue .tooltip-vue-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip-vue[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip-vue[x-placement^="top"] .tooltip-vue-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip-vue[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip-vue[x-placement^="bottom"] .tooltip-vue-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip-vue[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip-vue[x-placement^="right"] .tooltip-vue-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip-vue[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip-vue[x-placement^="left"] .tooltip-vue-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip-vue.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip-vue.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip-vue[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip-vue[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.vue-tooltip.tooltip-custom {
  background-color: white;
  color: #000;
}

.vue-tooltip.tooltip-custom .tooltip-arrow {
  border-color: 000;
  color: white;
  background-color: transparent;
  border-top-color: white;
}

.vue-notification {
  font-size: 14px !important;
}

.header-fast-delivery-modal {
  background-color: var(--secondary-color-1);
  color: var(--primary-color-1);
}

.body-fast-delivery-modal {
  h6 {
    color: red;
  }
}

.footer-fast-delivery-modal {
  button.btn-primary {
    color: white;
    background-color: var(--primary-color-1);
  }
}
</style>
